import React from 'react';
import Footer from './components/Footer';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';


const AccountDetailsFooter = ({
    onClick = () => { },
}) => {
    return (
        <Footer>
            <div>Check student & account details</div>
            <AButton
                onClick={onClick}
                className="button_remove_left_margin"
                variant="primary_filled"
            >
                Verify and re-initiate refund
            </AButton>
        </Footer>
    )
}

export default AccountDetailsFooter;